import { coachApi } from '@shared/api/client';
import type { CollectionRecord, CollectionItemRecord } from './types';
import {
  adaptCollectionRecord,
  adaptCollectionRecordList,
  adaptCollectionItemRecord,
  adaptCollectionItemRecordList,
} from './adapters';

export const cmsApi = {
  listCollections: async (siteId: string): Promise<CollectionRecord[]> => {
    const raw = await coachApi.get<unknown>(`/webbuilder/sites/${siteId}/collections`);
    return adaptCollectionRecordList(raw);
  },
  createCollection: async (
    siteId: string,
    data: { name: string; slug: string; schema_json: Record<string, unknown> }
  ): Promise<CollectionRecord> => {
    const raw = await coachApi.post<unknown>(`/webbuilder/sites/${siteId}/collections`, data);
    return adaptCollectionRecord(raw);
  },
  updateCollection: async (
    siteId: string,
    collectionId: string,
    data: { name: string; slug: string; schema_json: Record<string, unknown> }
  ): Promise<CollectionRecord> => {
    const raw = await coachApi.put<unknown>(`/webbuilder/sites/${siteId}/collections/${collectionId}`, data);
    return adaptCollectionRecord(raw);
  },
  listCollectionItems: async (collectionId: string): Promise<CollectionItemRecord[]> => {
    const raw = await coachApi.get<unknown>(`/webbuilder/collections/${collectionId}/items`);
    return adaptCollectionItemRecordList(raw);
  },
  createCollectionItem: async (
    collectionId: string,
    data: { item_slug: string; fields_json: Record<string, unknown>; status?: string }
  ): Promise<CollectionItemRecord> => {
    const raw = await coachApi.post<unknown>(`/webbuilder/collections/${collectionId}/items`, data);
    return adaptCollectionItemRecord(raw);
  },
};

export const webbuilderApi = cmsApi;
export type * from './types';
